import React from 'react';
import './InputForms.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import TextInput from './TextInput'
import Dropdown from './Dropdown'
import Checkbox from './Checkbox'
import TextArea from './TextArea'
import { SendEmailInterest } from './EmailService'

class InterestForm extends React.Component {
    state = {
        name: '',
        emailadress: '',
        wishToRent: '',
        squaremeters: '',
        telephoneNumber: '',
        employer: '',
        adultAmount: '',
        childrenAmount: '',
        animals: false,
        smoking: false,
        maxRent: '',
        comment: '',
        roomAmount: '',
        city: '',
        validData: null,
        mailSent: false,
        sendDisabled: false
    }

    validData = () => {
        return (this.state.name.length > 0
            && this.state.emailadress.length > 0
            && this.state.telephoneNumber.length > 0
            && this.state.wishToRent.length > 0
            && this.state.roomAmount.length > 0
            && this.state.squaremeters.length > 0
            && this.state.employer.length > 0
            && this.state.city.length > 0
            && this.state.maxRent.length > 0)
    }

    sendButtonClicked = async () => {
        this.setState({ sendDisabled: true, smoking: this.state.smoking, animals: this.state.animals })
        setTimeout(() => this.setState({ sendDisabled: false }), 3000);
        if (this.validData()) {
            await SendEmailInterest(this.state);
            this.setState({
                validData: true, name: '', city: '', emailadress: '', wishToRent: '', squaremeters: '', telephoneNumber: '', employer: '',
                familyAmount: '', animals: false, smoking: false, maxRent: '', comment: '', roomAmount: '', mailSent: true
            })
        }
        else {
            this.setState({ validData: false })
        }
    }

    render() {
        return <div className='interestContainer'>
            <div className='textArea'>
                Glimma fastigheter hyr ut både lokaler och lägenheter. Vår grundfilosofi är att finnas nära våra hyresgäster och vi vill skapa hus där alla trivs. Det gör vi genom bra och personlig service och korta beslutsvägar. Vill ni hyra hos oss gör du en intresseanmälan nedan. Alla intresseanmälningar tas bort efter två månader och om du fortfarande är intresserad av att hyra efter två månader måste du skicka in en ny intresseanmälan.
            </div>

            <h1>Intresseanmälan</h1>

            <TextInput onChange={(event: any) => this.setState({ name: event.target.value })} required={true} label={'Sökande För- & Efternamn'} value={this.state.name} />

            <TextInput onChange={(event: any) => this.setState({ emailadress: event.target.value })} required={true} label={'Epostadress'} value={this.state.emailadress} />

            <TextInput onChange={(event: any) => this.setState({ telephoneNumber: event.target.value })} required={true} label={'Telefonnummer'} value={this.state.telephoneNumber} />

            <Dropdown options={['', 'Alingsås', 'Borås', 'Vänersborg']} onChange={(event: any) => this.setState({ city: event.target.value })} required={true} label={'Vilken stad?'} value={this.state.city} />

            <Dropdown options={['', 'Lägenhet', 'Kontor', 'Lokal', 'Restauranglokal', 'Industrilokal', 'Parkeringsplats']} onChange={(event: any) => this.setState({ wishToRent: event.target.value })} required={true} label={'Vad önskar du hyra?'} value={this.state.wishToRent} />

            <Dropdown options={['', 1, 2, 3, 4, 5]} onChange={(event: any) => this.setState({ roomAmount: event.target.value })} required={true} label={'Önskat antal rum?'} value={this.state.roomAmount} />

            <TextInput onChange={(event: any) => this.setState({ squaremeters: event.target.value })} required={true} label={'Önskat antal kvadratmeter?'} value={this.state.squaremeters} />

            <TextInput onChange={(event: any) => this.setState({ employer: event.target.value })} required={true} label={'Arbetsgivare/Sysselsättning'} value={this.state.employer} />

            <Dropdown options={['', 1, 2, 3, 4, 5]} onChange={(event: any) => this.setState({ adultAmount: event.target.value })} required={true} label={'Antal vuxna i familj?'} value={this.state.adultAmount} />

            <Dropdown options={['', 1, 2, 3, 4, 5]} onChange={(event: any) => this.setState({ childrenAmount: event.target.value })} required={true} label={'Antal barn i familj?'} value={this.state.childrenAmount} />

            <Checkbox onChange={(event: any) => this.setState({ animals: !this.state.animals })} label={'Djur'} value={this.state.animals} />

            <Checkbox onChange={(event: any) => this.setState({ smoking: !this.state.smoking })} label={'Röker'} value={this.state.smoking} />

            <TextInput onChange={(event: any) => this.setState({ maxRent: event.target.value })} required={true} label={'Max månadshyra'} value={this.state.maxRent} />

            <TextArea placeholder="Exempel: Jag vill flytta till Alingsås eftersom jag fått jobb som fritidspedagog. Jag har ordnad ekonomi och inga betalningsanmärkningar. Har även en liten katt som är van vid att bo inomhus." onChange={(event: any) => this.setState({ comment: event.target.value })} label={'Kommentar'} value={this.state.comment} />

            <button className='sendButton' disabled={(this.state.sendDisabled || !this.validData())} onClick={() => this.sendButtonClicked()}>Skicka</button>

            {this.state.mailSent && <span className={'mailSent'}>Tack för att du kontaktade oss.</span>}
        </div>
    }
}

export default InterestForm